import React from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as AddPhoto } from 'icons/AddPhoto.svg';

import Container from 'styled/Editor/Container';
import SubBlock from 'styled/Editor/SubBlock';
import FormLabel from 'styled/Editor/FormLabel';
import LeftBlockWrapper from 'styled/Editor/LeftBlockWrapper';
import CenteredContainer from 'styled/Page/CenteredContainer';

import Loader from 'components/Loader';

import IconWrapper from './IconWrapper';

export class LoadFileBlock extends React.PureComponent {
  handleChange = (e) => {
    this.props.onLoad(e.target.files);
  }

  render() {
    return (
      <Container>
        <LeftBlockWrapper>
          <FormLabel>
            {this.props.label}

            {this.props.loading
              ? (<CenteredContainer><Loader /></CenteredContainer>)
              : (
                <React.Fragment>
                  <IconWrapper><AddPhoto /></IconWrapper>

                  <input type="file" multiple onChange={this.handleChange} />
                </React.Fragment>
              )
            }
          </FormLabel>
        </LeftBlockWrapper>

        <SubBlock />
      </Container>
    );
  }
}

LoadFileBlock.defaultProps = {
  label: '',
  onLoad: () => {},
  loading: false,
};

LoadFileBlock.propTypes = {
  label: PropTypes.string,
  onLoad: PropTypes.func,
  loading: PropTypes.bool,
};

export default LoadFileBlock;
